export default {
  'profile.name': 'Trang cá nhân',
  'accounts.userName': 'Tên Đăng nhập',
  'accounts.accountFullName': 'Tên người dùng',
  'accounts.email': 'Email',
  'accounts.phoneNumber': 'Số điện thoại',
  'profile.code.title': 'Không thể đăng nhập',
  'profile.code.content': 'Vui lòng hiện hệ admin hệ thống',
};
